<template>
  <section class="ba-mb-4">
    <h5 class="ba-mb-2 ba-font-bold ba-text-primary">Срок исполнения</h5>
    <div>
      <time>
        <span class="ba-mr-1">{{ item.startDate }}</span>
        <span class="ba-text-text-blue-grey">{{ item.startTime }}</span>
      </time>
      -
      <time>
        <span class="ba-mr-1">{{ item.endDate }}</span>
        <span class="ba-text-text-blue-grey">{{ item.endTime }}</span>
      </time>
    </div>
  </section>
</template>

<script>
export default {
  name: 'vis-approval-queue-task-term',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
